import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

import DefaultTemplate from '../TopMiniNav/TopMiniNav.config';
import * as styles from './AccessibilityButton.css';

const cx = classNames.bind(styles);

export const AccessibilityButton = ({ AccessibleView, isNative }) => {
    useEffect(() => {
        const scriptId = 'usntA40start';
        const existingScript = document.getElementById(scriptId);

        if (!existingScript) {
            const script = document.createElement('script');
            script.defer = true;
            script.id = scriptId;
            script.src = 'https://a40.usablenet.com/pt/c/jcpenney/cookiestorestart';
            document.head.appendChild(script);
        }
    }, []);

    const buttonStyles = dt(['text-black', 'text-small', 'underline']);
    const onUsableNetAnchorClicked = () => {
        /* istanbul ignore next */
        if (typeof window !== 'undefined' && window.enableUsableNetAssistive) {
            window.enableUsableNetAssistive();
        }
    };

    if (!AccessibleView || isNative) return null;

    return (
        <a
            id="header-accessible-view"
            data-automation-id="accessible-view"
            className={`UsableNetAssistive ${cx('accessibleView', buttonStyles)}`}
            onClick={onUsableNetAnchorClicked}
            href="#"
            title="By activating this link you will enable accessibility for all the data and features of the site"
            dangerouslySetInnerHTML={{ __html: AccessibleView.name }}
            suppressHydrationWarning
        />
    );
};

AccessibilityButton.propTypes = {
    AccessibleView: PropTypes.object,
    isNative: PropTypes.bool,
};

AccessibilityButton.defaultProps = {
    AccessibleView: {},
    isNative: false,
};

const mapStateToProps = (state) => ({
    AccessibleView: get(state, 'context.preferences.AccessibleView', DefaultTemplate),
    isNative: get(state, 'context.isNative', false),
});

const ConnectedAccessibilityButton = connect(mapStateToProps)(AccessibilityButton);
export default ConnectedAccessibilityButton;
